module.exports = __webpack_public_path__ + "img/hitogata_gray_4w.7de1b940.png";